// views
import Link from "next/link";

// utils
import { postUrl, getHref } from "~/utils/route";
import { truncate } from "~/utils/app";

export default (props) => {
  const titleText = props.post.full_title || props.post.title;
  const title = props.altTitle ? truncate(titleText) : titleText;

  return (
    <Link
      legacyBehavior
      href={getHref(props.post)}
      as={postUrl(props.post)}
    >
      <a
        className={props.className || ""}
        title={titleText}
        target="_blank"
      >
        {props.isText ? (
          <span style={{ ...props.style }}>{title}</span>
        ) : (
          <h3
            style={{ fontWeight: 400, fontSize: "14px", marginBottom: "0px" }}
          >
            {title}
          </h3>
        )}
      </a>
    </Link>
  );
};
